import React from "react";
import {
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import NovaLanding from "./components/NovaLanding";
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsAndConditions from "./components/TermsAndConditions";
import Eula from "./components/Eula";
import ConfirmSignup from "./pages/ConfirmSignUp";
import SupportPage from "@shared/components/SupportPage";

function App() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const marketplaceSession = searchParams.get("marketplace_session") || "";
  const marketplaceError = searchParams.get("marketplace_error") || "";
  /** Returning Marketplace buyer flag from fulfillment 302 (§2.4 bootstrap). */
  const marketplaceReturning =
    searchParams.get("marketplace") === "1" ||
    searchParams.get("marketplace") === "true";
  const signupNext = (searchParams.get("next") || "").trim().toLowerCase();

  const loginMarketplaceMessage = marketplaceReturning
    ? "Your workspace is ready — sign in."
    : "";

  return (
    <Routes>
      <Route path="/landing" element={<NovaLanding />} />
      <Route path="/privacypolicy" element={<PrivacyPolicy />} />
      <Route path="/termsandconditions" element={<TermsAndConditions />} />
      <Route path="/eula" element={<Eula />} />
      <Route path="/" element={<NovaLanding />} />
      <Route
        path="/login"
        element={
          <NovaLanding
            initialAuthModal="signin"
            initialSignInEmail={location.state?.email || ""}
            initialSignInMessage={
              location.state?.message ||
              searchParams.get("message") ||
              loginMarketplaceMessage
            }
            marketplaceReturning={marketplaceReturning}
          />
        }
      />
      <Route path="/confirm" element={<ConfirmSignup />} />
      <Route path="/support" element={<SupportPage homePath="/" />} />
      <Route
        path="/signup"
        element={
          <NovaLanding
            initialAuthModal="signup"
            marketplaceSession={marketplaceSession}
            marketplaceError={marketplaceError}
            marketplaceReturning={marketplaceReturning}
            signupNext={signupNext}
          />
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
